import { AccountingPageAttributes } from 'chaika-test-attributes';

import { PagesParams } from '@common/TabsNavigationPage';

import { ReportPage } from '../pages/ReportPage/ReportPage';
import { OrganizationDataPage } from '../pages/OrganizationDataPage/OrganizationDataPage';

export const enum DashboardName {
    TabReport = 'tabReport',
    OrganizationData = 'organizationData',
}

export const accountingPages: PagesParams[] = [
    {
        title: 'dataByOrganization',
        name: DashboardName.OrganizationData,
        page: OrganizationDataPage,
        dataTest: AccountingPageAttributes.OrganizationData,
    },
    {
        title: 'cReport',
        name: DashboardName.TabReport,
        page: ReportPage,
        dataTest: AccountingPageAttributes.TabReport,
    },
];
